import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import styled from '@emotion/styled';
import { rgba } from 'polished';
import Tippy from '@tippy.js/react';
import { followCursor } from 'tippy.js';

const Item = styled.div`
  display: block;
  text-align: left;
  overflow: hidden;
  position: relative;
  @media (max-width: ${props => props.theme.breakpoint.s}) {
    grid-column-end: span 2 !important;
    max-width: 100%;
    width: 100%;
  }
`;

const ItemTitle = styled.div`
  z-index: 1;
  position: relative;
  text-align: center;
  letter-spacing: 1.5px;
  color: ${props => props.theme.colors.bg};
  font-size: 0.75rem;
  opacity: 1;
  background: ${props => rgba(props.theme.colors.primary, 1)};
  padding-left: 0.1rem;
  padding-right: 0.1rem;
  text-transform: uppercase;
  line-height: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
`;

const Author = styled.div`
  position: relative;
  display: none;
  text-align: center;
  z-index: 1;
  letter-spacing: 1.5px;
  color: ${props => props.theme.colors.primary};
  font-size: 0.75rem;
  opacity: 1;
  background: black;
  padding-left: 0.1rem;
  padding-right: 0.1rem;
  line-height: 0.75rem;
  font-weight: 700;
  @media (max-width: ${props => props.theme.breakpoint.m}) {
    display: block;
  }
`;

const InfoContainer = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  margin: 2rem;
  text-transform: uppercase;
`;

const GridItem = ({ uid, image, alt, title, author }) => (
  <React.Fragment>
    <Item width={2} key={uid}>
      <Link to={`/${uid}`}>
        <Tippy
          animation="scale"
          placement="bottom"
          offset="5, 10"
          duration={0}
          delay={[0, 0]}
          followCursor
          content={author === 'Emilie & Niles' ? 'Edit by Kid Sister' : `Edit by ${author}`}
          plugins={[followCursor]}
          theme="translucent"
          hideOnClick={false}
          inertia
          interactive={false}
          flipOnUpdate
          lazy
        >
          <span tabIndex="0">
            <InfoContainer>
              {author === 'Emilie & Niles' ? <Author>Edit by Kid Sister</Author> : <Author>Edit by {author}</Author>}
              <ItemTitle>{title}</ItemTitle>
            </InfoContainer>
            <Img fluid={image} alt={alt} />
          </span>
        </Tippy>
      </Link>
    </Item>
  </React.Fragment>
);

export default GridItem;

GridItem.propTypes = {
  uid: PropTypes.string.isRequired,
  image: PropTypes.any.isRequired,
  alt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
};
